import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { AuthService } from './services/auth.service';
import { PopmodalService } from './services/popupmodel.service';
import { PopupModalComponent } from './components/popupmodel.component';
import { LoaderInterceptor } from './interceptors/loader.interceptor';

@NgModule({
  declarations: [PopupModalComponent],
  imports: [
    CommonModule
  ],
  providers: [
    AuthService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    PopmodalService, 
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }
  ],
  //commented as no more required after v9 upgrade
  //entryComponents: [PopupModalComponent],
  exports:[PopupModalComponent]
})
export class CoreModule { }
